var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',_vm._b({},'td',_vm.column.td,false),[_vm._t(_vm.slotName,[_c('span',[_vm._v(_vm._s(_vm.item[_vm.column.value] || ''))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }